import store from '@/store'
const CryptoJS = require('crypto-js')

// Encrypt a string using AES
const secretKey = process.env.VUE_APP_COOKIE_KEY

// Encrypt a string using AES encryption (CryptoJS)
const encryptString = (message) => CryptoJS.AES.encrypt(message, secretKey).toString()

// Decrypt an AES-encrypted string (CryptoJS)
const decryptString = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
  return bytes.toString(CryptoJS.enc.Utf8)
}

const set = (name, value) => {
  if (!value) {
    console.log('Value is undefined. Not setting state')
    return
  }
  try {
    const encryptedString = encryptString(value)
    store.commit('SET_COOKIE', { name, value: encryptedString })
  } catch (error) {
    console.error('Error setting cookie:', error)
  }
}

const get = (name) => {
  try {
    return decryptString(store.state.cookies[name] ?? '')
  } catch (error) {
    console.error('Error getting cookie:', error)
    return ''
  }
}

const remove = (name) => {
  try {
    store.commit('REMOVE_COOKIE', name)
  } catch (error) {
    console.error('Error removing cookie:', error)
  }
}

export const cookies = {
  get, set, remove,
}
